import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import ModalContent from "./ModalContent";

const TeamModal = ({ open, onClose, team }) => {
  const { name, faculty, major, backgrounds, image, role } = team;

  return (
    <ModalContent
      open={open}
      onClose={onClose}
      className={"flex flex-col gap-4 p-6 md:!min-w-[640px] rounded-3xl"}
    >
      <div className="flex flex-col md:flex-row items-center gap-4 relative">
        <AiOutlineClose
          size={24}
          className="absolute top-0 right-0 text-wce-neutral-8 cursor-pointer block md:hidden"
          onClick={onClose}
        />
        <div className="min-w-[72px] md:min-w-[120px]">
          <img
            className="w-[72px] h-[72px] md:w-[120px] md:h-[120px] rounded-full object-cover"
            src={image}
            alt="team"
          />
        </div>
        <div className="flex flex-col py-2 px-4 md:py-4 gap-1 rounded-2xl bg-wce-neutral-4 w-full">
          <span className="font-yesevaOne text-wce-pink-bright md:text-2xl">
            {name}
          </span>
          <span className="text-wce-navy text-sm md:text-base font-medium">
            {role}
          </span>
          <span className="text-wce-navy text-sm md:text-base">{`${major} - ${faculty}`}</span>
        </div>
        <AiOutlineClose
          size={24}
          className="text-wce-neutral-8 cursor-pointer hidden md:block"
          onClick={onClose}
        />
      </div>
      <div>
        <div
          className="text-wce-neutral-10 font-medium pb-2 
        border-b border-wce-neutral-5 text-sm md:text-base"
        >
          Background
        </div>
        <div className="mt-2 text-sm md:text-base">
          {backgrounds?.map((b) => (
            <span className="flex text-wce-neutral-10">&#x2022; {b}</span>
          ))}
        </div>
      </div>
    </ModalContent>
  );
};

export default TeamModal;
